import { makeStyles } from '@material-ui/styles'
import React from 'react'
import DropdownField from 'core/components/validatedForm/DropdownField'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import Theme from 'core/themes/model'
import DatabaseCard from './DatabaseCard'

export default function DatabaseEngineSelectionField({ databases, params, getParamsUpdater }) {
  const classes = useStyles()
  return (
    <div className={classes.databaseField}>
      <div className={classes.databaseCards}>
        {databases.map((database) => (
          <DatabaseCard
            key={database.name}
            id={database.name}
            title={database.name}
            description={database.description}
            logo={database.logo}
            onClick={() => getParamsUpdater('database')(database.name)}
            active={params.database === database.name}
          />
        ))}
      </div>
      <DropdownField
        id="databaseVersion"
        label="Version"
        DropdownComponent={AsyncDropdown}
        items={[
          { label: 'v16.0', value: 'v16.0' },
          { label: 'v15.6.2', value: 'v15.6.2' },
        ]}
        value={params.databaseVersion}
        onChange={(value) => getParamsUpdater('databaseVersion')(value)}
        required
      />
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  databaseField: {
    display: 'grid',
    gridGap: theme.spacing(2),
  },
  databaseCards: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gridGap: theme.spacing(2),
  },
}))
